import { DOOH_REPORT_OUTLETS } from './config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case DOOH_REPORT_OUTLETS:
            return action.payload;
        
        default:
            return state;
    }
}

export default reducer;